import { render, staticRenderFns } from "./LicensesComp.vue?vue&type=template&id=6e4e9ab0&scoped=true&"
import script from "./LicensesComp.vue?vue&type=script&lang=js&"
export * from "./LicensesComp.vue?vue&type=script&lang=js&"
import style0 from "./LicensesComp.vue?vue&type=style&index=0&id=6e4e9ab0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4e9ab0",
  null
  
)

export default component.exports